import angular from 'angular';

let UserService = function($resource) {
    var baseUrl = '/user/api/users';
    return $resource(
        baseUrl+'/:action',
        {action:'@action'},
        {
            checkEmail: { method: 'GET', params: {action:'checkEmail'} },
            checkForEmailUpdate: { method: 'GET', params: {action:'checkForEmailUpdate'} },
            updateDetails : { method: 'PUT', params: { action:'details'} },
            changePassword : { method: 'PUT', params: { action:'changePassword'} },
            changeEmail : { method: 'PUT', params: { action:'changeEmail'} },
            resendValidationEmail : { method: 'GET', params: { action:'resendValidationEmail'} },
            resetPassword : { method:'POST', url:'/recoverpassword'}
        }
    )
}

UserService.$inject = [ '$resource' ];

export default angular.module("user.services", []).service("userServices", UserService).name;


// WEBPACK FOOTER //
// ./js/legacy/app/user/services.js